import { fetchSelectablePatches } from "$lib/utils/patches";
import type { LayoutLoad } from "./$types";

export const load: LayoutLoad = async ({ fetch }) => {
    return { balancePatches: await fetchSelectablePatches(fetch) };
};
